<template>
  <div class="row py-5">
    <div class="col">
      <div class="h3 pb-2 mb-0 text-center border-success border-bottom border-0">Operating Data</div>
      <div class="row">
        <div v-for="(sensor, key) in selectSensors(operatingKeys)" :key="key" class="col-12">
          <mz-gauge :id="key"
            :value="sensor.value"
            :valueFormatter="sensor.valueFormatter"
            :status="sensor.status"
            :marker="sensor.marker" 
            :header="sensor.label"
            :unit="sensor.unit"
            :min="sensor.min"
            :max="sensor.max"
            :icon="sensor.icon"
            :checks="sensor.checks"
            :labels="sensor.labels"
            :css="sensor.css"
            data-toggle="modal"
            :data-target="'#modal-' + key">
          </mz-gauge>
          <mz-modal :id="'modal-' + key">
            <mz-line-chart
              :icon="sensor.icon"
              :header="sensor.label"
              :ranges="sensor.valueRanges"
              :min="sensor.min"
              :max="sensor.max"
              :id="'health-' + key"
              :unit="sensor.unit"
              :data="sensor.history"></mz-line-chart>
          </mz-modal>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="h3 pb-2 mb-0 text-center border-success border-bottom border-0">Health Data</div>
      <div class="row">
        <div v-for="(sensor, key) in selectSensors(healthKeys)" :key="key" class="col-12">
          <mz-gauge :id="key"
            :value="sensor.value"
            :valueFormatter="sensor.valueFormatter"
            :status="sensor.status"
            :marker="sensor.marker" 
            :header="sensor.label"
            :unit="sensor.unit"
            :min="sensor.min"
            :max="sensor.max"
            :icon="sensor.icon"
            :checks="sensor.checks"
            :labels="sensor.labels"
            :css="sensor.css"
            data-toggle="modal"
            :data-target="'#modal-' + key">
          </mz-gauge>
          <mz-modal :id="'modal-' + key">
            <mz-line-chart
              :icon="sensor.icon"
              :header="sensor.label"
              :ranges="sensor.valueRanges"
              :min="sensor.min"
              :max="sensor.max"
              :unit="sensor.unit"
              :id="'health-' + key"
              :data="sensor.history"></mz-line-chart>
          </mz-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import PageImage from '@/components/layout/PageImage'
import Gauge from '@/components/charts/Gauge'
import Modal from '@/components/modal/Modal'
import LineChart from '@/components/charts/LineChart'

import { mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'

export default {
  name: 'healthReport',
  data () {
    return {
      title: 'Health Report',
      icon: 'stethoscope',
      operatingKeys: [
        'tro',
        'spo',
        'tge',
        'toi'
      ],
      healthKeys: [
        'loi',
        'qoi',
        'hge',
        'lft'
      ]
    }
  },
  computed: {
    ...mapGetters(['sensors'])
  },
  methods: {
    ...mapMutations(['setPageTitle']),
    selectSensors (sensorKeys) {
      return (_.pick(this.sensors, sensorKeys))
    }
  },
  components: {
    mzPageHeader: PageHeader,
    mzPageImage: PageImage,
    mzGauge: Gauge,
    mzLineChart: LineChart,
    mzModal: Modal
  },
  created () {
    this.setPageTitle({ title: this.title, icon: this.icon })
  },
  mounted () {
  }
}
</script>

<style>
  .border-2 {
    border-width: 2px !important;
  }
  .border-5 {
    border-width: 5px !important;
  }
  .border-10 {
    border-width: 10px !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/views/health-report/HealthReport.vue